import React from "react";
import type { ReactNode } from "react";

import { Value } from "@components/Text";

import breakRow from "./breakRow";
import renderBoolean from "./renderBoolean";
import renderAdditional from "./renderAdditional";
import renderResidenceState from "./renderResidenceState";
import type { DescriptionItem, Investor, ProfileIndividual } from "./types";

const LABEL_SSN = "Social Security Number";
const LABEL_TITLE = "Title of Membership Interests";
const LABEL_SINGLE = "Individually, as a single person";
const LABEL_MARRIED = "A married person, as my sole and separate property";
const LABEL_INVESTMENTS = "Investments";

const FULL_ROW_SPAN = 2;

const renderProfileIndividual = (
  profileIndividual: ProfileIndividual,
  formattedInvestments?: ReactNode,
  investor?: Investor,
  additionalExtra?: ReactNode,
): DescriptionItem[] => {
  const {
    ssnNumber,
    isMarriedAndSeparateProperty,
  } = profileIndividual;

  const { address = {} } = investor;
  const { addressRegion, addressCountry } = address;

  const items: DescriptionItem[] = [
    {
      span: FULL_ROW_SPAN,
      label: LABEL_TITLE,
      value: renderBoolean(isMarriedAndSeparateProperty, LABEL_MARRIED, LABEL_SINGLE),
    },
    {
      label: LABEL_SSN,
      value: <Value value={ssnNumber} />,
    },
  ];

  if (formattedInvestments) {
    items.push({
      label: LABEL_INVESTMENTS,
      value: formattedInvestments,
    });
  }

  const residenceItems = renderResidenceState(profileIndividual, addressCountry, addressRegion);

  const allItems = [ ...items, ...residenceItems ];

  breakRow(allItems);

  allItems.push(renderAdditional(profileIndividual, additionalExtra));

  return allItems;
};

export default renderProfileIndividual;
